import * as React from 'react';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import '../reservations/reservationCompletePane.module.scss';
import { ReservationPane } from '../../atoms/reservations/ReservationPane';

type Props = {
    onCompleteClick: () => any;
};

export class WithdrawalCancelCompletePane extends React.Component<Props> {
    render() {
        const { onCompleteClick } = this.props;
        return (
            <ReservationPane styleName="pane" id="withdrawal-cancel-complete-pane">
                <div styleName="text">退会申請を取り消しました</div>
                <div styleName="date">
                    退会申請が取り消しされたのでこれまで通りSHElikesのサービスをご利用いただけます。
                </div>
                <div styleName="button-wrapper">
                    <Button styleName="button" type="primary" size="m" disabled={false} onClick={onCompleteClick}>
                        マイページへ戻る
                    </Button>
                </div>
            </ReservationPane>
        );
    }
}
